






















































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import WorkOrderPane from '@/components/work_order/work-order-pane.vue'
import { RequestPaging } from '@/utils/util'
import {
  apiWorkOrderLists,
  apiStaffAllList,
  apiWorkOrderBatchAssign,
  apiWorkOrderBatchCancel,
  apiWorkOrderDetail,
  apiGetQuotationList,
  apiAddQuotation
} from '@/api/work_order'
import { apiMaterialLists } from '@/api/material'

@Component({
  components: {
    WorkOrderPane
  }
})
export default class WorkOrderList extends Vue {
    queryObj: any = {
      keyword: '',
      order_type: '',
      order_status: '',
      urgency_level: '',
      payment_status: '',
      assigned_staff_id: '',
      create_time_range: [],
      scheduled_time_range: []
    }

    // 工单类型列表
    orderTypeList: any[] = [
      { value: '1', label: '保洁工单' },
      { value: '2', label: '维修工单' },
      { value: '3', label: '安保工单' },
      { value: '4', label: '接待工单' },
      { value: '5', label: '入住检查' },
      { value: '6', label: '退房检查' },
      { value: '7', label: '设备巡检' },
      { value: '8', label: '绿化维护' }
    ]

    // 工单状态列表
    orderStatusList: any[] = [
      { value: '1', label: '待指派' },
      { value: '2', label: '已指派' },
      { value: '3', label: '进行中' },
      { value: '4', label: '已完成' },
      { value: '5', label: '已验收' },
      { value: '6', label: '已取消' },
      { value: '7', label: '已转单' },
      { value: '8', label: '需补差价' },
      { value: '9', label: '已报价' }
    ]

    staffList: any[] = [] // 员工列表
    selectedIds: number[] = [] // 选中的工单ID

    // 报价相关数据
    quotationDialogVisible = false // 报价对话框可见性
    detailLoading = false // 工单详情加载状态
    currentWorkOrderId = 0 // 当前工单ID
    workOrderDetail: any = null // 工单详情数据
    selectedMaterials: any[] = [] // 已选择的物料列表
    quotationData: any = null // 报价单数据
    editableStaffs: any[] = [] // 可编辑的员工信息数组，包含id、duration_hours、internal_labor_cost和external_labor_cost

    // 报价单总计数据
    quotationTotal = {
      materialTotal: 0, // 物料总费用
      staffTotal: 0, // 员工总费用
      total: 0 // 总费用
    }

    // 定金相关数据
    depositPercentage = 30 // 定金百分比，默认30%
    depositAmount = 0 // 定金金额
    balanceAmount = 0 // 尾款金额
    progressPaymentAmount = 0 // 进度款池（尾款金额，需 > 0 才能生成进度款记录）

    // 物料选择相关数据
    materialSelectorVisible = false // 物料选择对话框可见性
    materialLoading = false // 物料列表加载状态
    materialList: any[] = [] // 物料列表
    materialQuery: any = { keyword: '' } // 物料查询参数
    materialPager = new RequestPaging() // 物料分页数据
    tempSelectedMaterials: any[] = [] // 临时选择的物料（在对话框中）

    pickerOptions = {
      shortcuts: [{
        text: '最近一周',
        onClick (picker: any) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      }, {

        text: '最近一个月',
        onClick (picker: any) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      }, {
        text: '最近三个月',
        onClick (picker: any) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }]
    }

    pager = new RequestPaging()
    apiWorkOrderLists = apiWorkOrderLists

    getList (page?: number): void {
      page && (this.pager.page = page)

      // 处理时间范围参数
      const params: any = { ...this.queryObj }

      if (params.create_time_range && params.create_time_range.length === 2) {
        params.create_time_start = params.create_time_range[0]
        params.create_time_end = params.create_time_range[1]
        delete params.create_time_range
      }

      if (params.scheduled_time_range && params.scheduled_time_range.length === 2) {
        params.scheduled_time_start = params.scheduled_time_range[0]
        params.scheduled_time_end = params.scheduled_time_range[1]
        delete params.scheduled_time_range
      }

      this.pager
        .request({
          callback: apiWorkOrderLists,
          params
        })
    }

    // 重置查询条件
    handleReset () {
      this.queryObj = {
        keyword: '',
        order_type: '',
        order_status: '',
        urgency_level: '',
        payment_status: '',
        assigned_staff_id: '',
        create_time_range: [],
        scheduled_time_range: []
      }
      this.selectedIds = []
      this.getList(1)
    }

    // 创建工单
    handleAdd () {
      this.$router.push({
        path: '/work_order/create',
        query: { from: 'list' }
      })
    }

    // 导出功能
    handleExport () {
      this.$confirm('确认导出工单数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 导出实现
        console.log('导出工单数据')
      })
    }

    // 批量操作
    handleBatchCommand (command: string) {
      switch (command) {
        case 'assign':
          this.handleBatchAssign()
          break
        case 'cancel':
          this.handleBatchCancel()
          break
        case 'export':
          this.handleBatchExport()
          break
      }
    }

    // 批量派工
    async handleBatchAssign () {
      try {
        const result = await this.$prompt('请输入指派备注', '批量派工', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S+/,
          inputErrorMessage: '请输入指派备注'
        }) as any

        const value = result.value
        await apiWorkOrderBatchAssign({ // 使用正确的函数名
          ids: this.selectedIds,
          remark: value
        })

        this.$message.success('批量派工成功')
        this.selectedIds = []
        this.getList()
      } catch (error) {
        // 用户点击取消
        console.log('用户取消操作')
      }
    }

    // 批量取消
    async handleBatchCancel () {
      try {
        const result = await this.$prompt('请输入取消原因', '批量取消', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S+/,
          inputErrorMessage: '请输入取消原因'
        }) as any

        const value = result.value
        await apiWorkOrderBatchCancel({ // 使用正确的函数名
          ids: this.selectedIds,
          reason: value
        })

        this.$message.success('批量取消成功')
        this.selectedIds = []
        this.getList()
      } catch (error) {
        // 用户点击取消
        console.log('用户取消操作')
      }
    }

    // 批量导出
    handleBatchExport () {
      // 实现批量导出
    }

    // 表格选择事件
    handleSelectionChange (ids: number[]) {
      this.selectedIds = ids
    }

    // 编辑工单
    handleEdit (id: any) {
      this.$router.push({
        path: '/work_order/edit',
        query: { id }
      })
    }

    // 查看详情
    handleDetail (id:any) {
      this.$router.push({
        path: '/work_order/detail',
        query: { id }
      })
    }

    // 派工
    handleAssign (id:any) {
      this.$router.push({
        path: '/work_order/dispatch',
        query: { work_order_id: id.toString() }
      })
    }

    // 取消工单
    async handleCancel (id: number) {
      try {
        const result = await this.$prompt('请输入取消原因', '取消工单', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S+/,
          inputErrorMessage: '请输入取消原因'
        }) as any // 类型断言

        const value = result.value
        // 调用取消API
        console.log('取消工单:', id, value)
        // 成功后刷新列表
        this.getList()
      } catch (error) {
        // 用户点击取消
        console.log('用户取消操作')
      }
    }

    // 报价管理
    handleQuotation (id: number) {
      this.currentWorkOrderId = id
      this.quotationDialogVisible = true
      this.getWorkOrderDetail(id)
      this.getMaterialList()
      this.selectedMaterials = []
      this.quotationData = null
      this.editableStaffs = [] // 重置可编辑员工数组
    }

    // 获取工单详情
    getWorkOrderDetail (id: number) {
      this.detailLoading = true
      apiWorkOrderDetail({ id }).then((res: any) => {
        this.workOrderDetail = res
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    }

    // 获取物料列表
    getMaterialList (page?: number) {
      this.materialLoading = true
      page && (this.materialPager.page = page)

      this.materialPager
        .request({
          callback: apiMaterialLists,
          params: {
            ...this.materialQuery
          }
        })
        .then(() => {
          this.materialList = this.materialPager.lists || []
          this.materialLoading = false
        })
        .catch(() => {
          this.materialLoading = false
        })
    }

    // 打开物料选择器
    openMaterialSelector () {
      this.materialSelectorVisible = true
      this.tempSelectedMaterials = []
      this.getMaterialList()
    }

    // 物料选择变化
    handleMaterialSelection (selection: any[]) {
      this.tempSelectedMaterials = selection
    }

    // 确认物料选择
    confirmMaterialSelection () {
      // 将临时选择的物料添加到已选物料列表，设置默认数量为1
      this.tempSelectedMaterials.forEach((material: any) => {
        // 检查是否已经选择过该物料
        const existingIndex = this.selectedMaterials.findIndex(
          (item: any) => item.id === material.id
        )

        if (existingIndex === -1) {
          // 添加新物料，设置默认数量为1
          this.selectedMaterials.push({
            ...material,
            quantity: 1
          })
        }
      })

      this.materialSelectorVisible = false
      this.updateQuotationTotal()
    }

    // 移除物料
    removeMaterial (index: number) {
      this.selectedMaterials.splice(index, 1)
      this.updateQuotationTotal()
    }

    // 验证数量
    validateQuantity (material: any) {
      if (material.quantity > material.stock) {
        this.$message.warning(`数量不能超过库存 (${material.stock})`)
        material.quantity = material.stock
      }
      this.updateQuotationTotal()
    }

    // 搜索物料
    searchMaterials () {
      this.getMaterialList(1)
    }

    // 物料分页大小变化
    handleMaterialSizeChange (size: number) {
      this.materialPager.size = size
      this.getMaterialList(1)
    }

    // 物料页码变化
    handleMaterialCurrentChange (page: number) {
      this.getMaterialList(page)
    }

    // 生成报价单
    generateQuotation () {
      if (this.selectedMaterials.length === 0) {
        this.$message.warning('请先选择物料')
        return
      }

      // 准备报价单数据
      const materials = this.selectedMaterials.map((item: any) => ({
        material_id: item.id,
        quantity: item.quantity
      }))

      // 初始化可编辑员工信息
      this.editableStaffs = this.workOrderDetail.assigned_staff.map((staff: any) => ({
        id: staff.id,
        staff_name: staff.staff_name,
        is_primary: staff.is_primary,
        duration_hours: staff.duration_hours || 0,
        internal_labor_cost: staff.internal_salary ?? staff.salary_amount ?? 0,
        external_labor_cost: staff.external_salary ?? staff.salary_amount ?? 0
      }))

      // 调用获取报价单API
      const params = {
        work_order_id: this.currentWorkOrderId,
        staff_ids: this.editableStaffs.map(staff => staff.id),
        materials: materials
      }

      apiGetQuotationList(params).then((res: any) => {
        // 处理报价单数据
        const data = res || {}
        const staffsFromAPI = Array.isArray(data.staff) ? data.staff : [data.staff || {}]
        const materialsFromAPI = Array.isArray(data.materials) ? data.materials : [data.materials || {}]

        // 更新可编辑员工数组，使用API返回的 internal_salary、external_salary、duration_hours
        this.editableStaffs = this.editableStaffs.map(editableStaff => {
          const staffFromAPI = staffsFromAPI.find((staff: any) => staff.id === editableStaff.id)
          return {
            ...editableStaff,
            duration_hours: staffFromAPI?.duration_hours ?? editableStaff.duration_hours,
            internal_labor_cost: staffFromAPI?.internal_salary ?? staffFromAPI?.labor_cost ?? editableStaff.internal_labor_cost,
            external_labor_cost: staffFromAPI?.external_salary ?? staffFromAPI?.labor_cost ?? editableStaff.external_labor_cost
          }
        })

        // 更新物料数组，使用API返回的单价和数量
        this.selectedMaterials = this.selectedMaterials.map(selectedMaterial => {
          const materialFromAPI = materialsFromAPI.find((material: any) => material.material_id == selectedMaterial.id)
          return {
            ...selectedMaterial,
            unit_price: materialFromAPI?.unit_price || 0,
            quantity: materialFromAPI?.quantity || selectedMaterial.quantity
          }
        })

        // 标记报价单已生成，用于控制预览显示
        this.quotationData = true

        // 计算报价单总计数据
        this.updateQuotationTotal()

        this.$message.success('报价单生成成功')
      }).catch((error: any) => {
        this.$message.error('生成报价单失败：' + (error.message || '未知错误'))
      })
    }

    // 更新报价单总计数据
    updateQuotationTotal () {
      // 计算物料总费用
      const materialTotal = this.selectedMaterials.reduce((total: number, item: any) => {
        const unitPrice = parseFloat(item.unit_price || '0') || 0
        const quantity = parseFloat(item.quantity || '0') || 0
        const itemTotal = unitPrice * quantity
        return total + itemTotal
      }, 0)

      // 计算员工总费用（使用对外薪酬，即向客户收取的金额）
      const staffTotal = this.editableStaffs.reduce((total: number, staff: any) => {
        const externalCost = parseFloat(staff.external_labor_cost || '0') || 0
        return total + externalCost
      }, 0)

      // 更新报价单总计数据
      this.quotationTotal = {
        materialTotal,
        staffTotal,
        total: materialTotal + staffTotal
      }

      // 更新定金金额
      this.updateDepositAmount()
    }

    // 更新定金金额
    updateDepositAmount () {
      this.depositAmount = (this.quotationTotal.total * (this.depositPercentage / 100))
      this.balanceAmount = this.quotationTotal.total - this.depositAmount
      this.progressPaymentAmount = this.balanceAmount // 进度款池 = 尾款金额
    }

    // 提交报价单
    submitQuotation () {
      this.$confirm('确认提交此报价单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 准备提交数据
          const submitData = {
            title: this.workOrderDetail.order_title || '报价单',
            work_order_id: this.currentWorkOrderId,
            staffs: this.editableStaffs.map(staff => ({
              id: staff.id,
              duration_hours: staff.duration_hours,
              internal_salary: parseFloat(staff.internal_labor_cost) || 0,
              external_salary: parseFloat(staff.external_labor_cost) || 0
            })),
            materials: this.selectedMaterials.map((item: any) => ({
              material_id: item.id,
              quantity: item.quantity || 1,
              purchase_price: parseFloat(item.last_purchase_price) || 0,
              retail_price: parseFloat(item.retail_price) || 0
            })),
            total_material_cost: this.quotationTotal.materialTotal,
            total_labor_cost: this.quotationTotal.staffTotal,
            total_amount: this.quotationTotal.total,
            deposit_amount: this.depositAmount,
            deposit_percentage: this.depositPercentage,
            final_payment_amount: this.balanceAmount,
            progress_payment_amount: this.progressPaymentAmount
          }

          // 调用提交报价单API
          const result = await apiAddQuotation(submitData)

          if (result) {
            this.quotationDialogVisible = false
            // 刷新列表
            this.getList()
          } else {
          }
        } catch (error) {
          console.error('提交报价单错误:', error)
        }
      }).catch(() => {
        this.$message.info('已取消提交')
      })
    }

    // 查看报价单
    viewQuotation () {
      // 这里可以打开一个新窗口或对话框显示报价单
      this.$message.success('报价单已在下方显示')
    }

    // 获取状态标签类型
    getStatusTagType (status: number) {
      const statusMap: { [key: number]: string } = {
        1: 'info', // 待指派
        2: 'warning', // 已指派
        3: 'primary', // 进行中
        4: 'success', // 已完成
        5: 'success', // 已验收
        6: 'danger', // 已取消
        7: 'info', // 已转单
        8: 'warning' // 需补差价
      }
      return statusMap[status] || 'info'
    }

    // 获取紧急程度标签类型
    getUrgencyTagType (level: number) {
      const levelMap: { [key: number]: string } = {
        1: 'info', // 普通
        2: 'warning', // 紧急
        3: 'danger' // 加急
      }
      return levelMap[level] || 'info'
    }

    // 支付管理
    handlePayment (id: number) {
      this.$router.push({
        path: '/work_order/payment/detail',
        query: { work_order_id: id.toString() }
      })
    }

    // 获取员工列表
    getStaffList () {
      apiStaffAllList().then((res: any) => {
        this.staffList = res.lists || []
      })
    }

    created () {
      this.getStaffList()
      this.getList()
    }

    activated () {
      this.getList()
    }
}
